import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TableRow, TableCell, Button, Icon } from "semantic-ui-react";
import { setSlotState } from "../queries.jsx";
import { useMutation } from "react-query";
import errorHandler from "../ErrorHandler.jsx";
import { getTimestamp } from "../TimeStamp.jsx";

const AdminTableRow = ({ appointment, refetchTable, day }) => {
    const { t } = useTranslation();
    
    const { start_time, name, course_name, is_disabled, email, notes, phone_number } = appointment;

    const setTimeslotMutation = useMutation(setSlotState, {
        onSettled: (response) => {refetchTable(); errorHandler(response, t)},
    });

    

    const handleEnableTimeslot = () => {
        setTimeslotMutation.mutate({ time: getTimestamp(start_time, day), state: true})
    }

    const handleDisableTimeslot = () => {
        setTimeslotMutation.mutate({ time: getTimestamp(start_time, day), state:false });
    }

    return is_disabled ? (
        <TableRow>
            <TableCell>{start_time}</TableCell>
            <TableCell><Icon name='ban'/></TableCell>
            <TableCell><Icon name='ban'/></TableCell>
            <TableCell><Icon name='ban'/></TableCell>
            <TableCell><Icon name='ban'/></TableCell>
            <TableCell><Icon name='ban'/></TableCell>
            <TableCell>
                <div>
                    <Button size="small" color="blue" onClick={() => handleEnableTimeslot()}>{t('enable-timeslot')}</Button>
                </div>
            </TableCell>
        </TableRow>
    ) : (
        <TableRow>
            <TableCell width={1}>{start_time}</TableCell>
            <TableCell width={2}>{name}</TableCell>
            <TableCell width={2}>{course_name}</TableCell>
            <TableCell width={2}>{phone_number}</TableCell>
            <TableCell width={2}>{email}</TableCell>
            <TableCell width={2}>{notes}</TableCell>
            <TableCell width={2}>
                <div>
                    <Button size="small" color="red" onClick={() => handleDisableTimeslot()}>{t('disable-timeslot')}</Button>
                </div>
            </TableCell>
        </TableRow>
    );
}

export default AdminTableRow;